import { Component, Input } from '@angular/core';
import { WwePortfolioPosition } from '@ddt-web/wealth-web';


@Component({
	selector: 'hl-proxy-list-overview',
	templateUrl: './proxy-list-overview.component.html',
	styleUrls: ['./proxy-list-overview.component.scss']
})
export class ProxyListOverviewComponent {
	@Input() public portfolios: WwePortfolioPosition[];
}
